import { styled } from '@mui/material';
import hljs from 'highlight.js';
import { memo } from 'react';
import { SyntaxHighlight } from './SyntaxHighlight';

export type CodeHighlightRenderProps = {
  code: string;
  language?: string;
};

export const CodeHighlightRender = memo(
  ({ code, language }: CodeHighlightRenderProps) => {
    let gen = '';
    try {
      if (language) {
        gen = hljs.highlight(code, { language }).value;
      } else {
        gen = hljs.highlightAuto(code).value;
      }
    } catch (e) {
      gen = code;
    }

    return (
      <SyntaxHighlight>
        <StyledPre>
          <code
            dangerouslySetInnerHTML={{ __html: gen }}
            data-node-view-wrapper
          />
        </StyledPre>
      </SyntaxHighlight>
    );
  },
);

const StyledPre = styled('pre')(() => ({
  maxWidth: '100%',
}));
